/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetEnrollmentResponse } from './GetEnrollmentResponse';
import {
    GetEnrollmentResponseFromJSON,
    GetEnrollmentResponseFromJSONTyped,
    GetEnrollmentResponseToJSON,
    GetEnrollmentResponseToJSONTyped,
} from './GetEnrollmentResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetEnrollmentResponse
 */
export interface PaginatedResultOfGetEnrollmentResponse {
    /**
     * 
     * @type {Array<GetEnrollmentResponse>}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    items?: Array<GetEnrollmentResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetEnrollmentResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetEnrollmentResponse interface.
 */
export function instanceOfPaginatedResultOfGetEnrollmentResponse(value: object): value is PaginatedResultOfGetEnrollmentResponse {
    return true;
}

export function PaginatedResultOfGetEnrollmentResponseFromJSON(json: any): PaginatedResultOfGetEnrollmentResponse {
    return PaginatedResultOfGetEnrollmentResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetEnrollmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetEnrollmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetEnrollmentResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetEnrollmentResponseToJSON(json: any): PaginatedResultOfGetEnrollmentResponse {
    return PaginatedResultOfGetEnrollmentResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetEnrollmentResponseToJSONTyped(value?: PaginatedResultOfGetEnrollmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetEnrollmentResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

